import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addDepartment, fetchDepartments } from "../../API/department";
import { addNewField, addRole } from "../../API/role";
import DepartmentDropDown from "../common/DepartmentDropDown";
import EmployeeTypeDropDown from "../common/EmployeeTypeDropDown";
import Page from "../common/Page";
import AddField from "./elements/AddField";
import BankAccDetails from "./elements/BankAccDetails";
import DocumentSection from "./elements/DocumentSection";
import PersonalInfo from "./elements/PersonalInfo";

function CreateRole() {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [addField, setAddField] = useState(false);
  const [dept, setDept] = useState();
  const [empType, setEmpType] = useState();
  const [personalDetails, setPersonalDetails] = useState({});
  const [documents, setDocuments] = useState({});
  const [bankDetails, setBankDetails] = useState(false);
  const [newPersonalInfoFields, setNewPersonalInfoFields] = useState([]);
  const [newDocumentsFields, setNewDocumentsFields] = useState([]);
  const navigate = useNavigate();

  console.log(dept, "dept value");

  return (
    <Page>
      <div className=" flex flex-col sm:flex-row sm:items-center sm:justify-between ">
        <div className="flex ">
          <p
            onClick={() => navigation("/RoleManagement")}
            className=" text-md  sm:text-lg text-slate-500 font-medium cursor-pointer"
          >
            Role Management
          </p>
          <span className="text-md  sm:text-lg  text-slate-500 font-medium mx-1">
            /
          </span>
          <p className="text-md  sm:text-lg text-slate-700 font-medium">
            Create Role
          </p>
        </div>
        <span className="m-1 sm:m-0" />
        <div className="flex justify-center">
          <button
            onClick={() => setAddField(true)}
            className="px-8 py-1 max-w-3   border-2 border-buttonColor rounded-lg bg-[#3C69DF] hover:bg-[#284ba3] text-white text-bold"
          >
            Add field
          </button>
          {addField && (
            <AddField
              onClickHandler={() => setAddField(false)}
              onSave={(section, newFieldName) => {
                if (section === "Personal Details") {
                  setNewPersonalInfoFields([
                    ...newPersonalInfoFields,
                    { text: newFieldName, name: `extra${newFieldName}` },
                  ]);
                } else if (section === "Document Upload") {
                  setNewDocumentsFields([
                    ...newDocumentsFields,
                    { text: newFieldName, name: `extra${newFieldName}` },
                  ]);
                }
                toast.success("Field Added!", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                });
                setAddField(false);
              }}
            />
          )}
        </div>
      </div>
      <div className="mt-2" />
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between sm:mt-2">
        <DepartmentDropDown value={dept} onChange={(value) => setDept(value)} />
        <EmployeeTypeDropDown
          dept={dept}
          value={empType}
          onChange={(value) => setEmpType(value)}
        />
      </div>
      <div className="mt-2" />
      <PersonalInfo
        setPersonalDetails={setPersonalDetails}
        personalDetails={personalDetails}
        newPersonalInfoFields={newPersonalInfoFields}
        setNewPersonalInfoFields={setNewPersonalInfoFields}
      />
      <div className="mt-6" />
      <DocumentSection
        documents={documents}
        setDocuments={setDocuments}
        newDocumentsFields={newDocumentsFields}
        setNewDocumentsFields={setNewDocumentsFields}
      />
      <div className="mt-6" />
      <BankAccDetails
        bankDetails={bankDetails}
        setBankDetails={setBankDetails}
      />
      <div className="flex justify-center pb-10">
        <button
          onClick={() => {
            setLoading(true);
            addRole(dept, empType, personalDetails, documents, bankDetails)
              .then(async function (response) {
                console.log(response);
                setLoading(false);
                toast.success(response?.data?.msg, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 2000,
                });

                navigate("/RoleManagement");
              })
              .catch(function (error) {
                console.log(error);
                setLoading(false);
                toast.error("Something went wrong!", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 2000,
                });
              });
          }}
          className="px-8 py-1 max-w-3   border-2 border-buttonColor rounded-lg bg-[#3C69DF] hover:bg-[#284ba3] text-white text-bold"
        >
          {loading ? (
            <svg
              class="inline mr-2 w-8 h-8  animate-spin text-white fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : (
            "  Save changes"
          )}
        </button>
      </div>
    </Page>
  );
}

export default CreateRole;
